module.exports = __webpack_public_path__ + "img/p117.953a42cc.jpg";